import { Question as QuestionModel } from "../models/question";
import { Option as OptionModel } from "../models/option";
import { Option } from "./Option";
import { useEffect, useState } from "react";

type Props = {
    question: QuestionModel;
    complete: (points: number) => void;
}

export const Question = ({ question, complete }: Props) => {

    const [points, setPoints] = useState(10);
    const [selectedOption, setSelectedOption] = useState<OptionModel | null>(null);

    useEffect(() => {
        setSelectedOption(null);
        setPoints(10);
    }, [question])

    const handleOptionSelected = (option: OptionModel) => {
        if (selectedOption?.correct) {
            return;
        }

        setSelectedOption(option);
        setPoints(p => p <= 3 ? 0 : Math.ceil(p / 2));

        if (option.correct) {
            complete(points);
        }
    }
    
    return (
        <div className="question">
            <header>
                <h2>{question.title}</h2>
            </header>

            <section>
                <div className="options">
                    {question.options.map((option: OptionModel) => (
                        <Option key={option.id} option={option} setOption={handleOptionSelected} isSelected={selectedOption?.id === option.id} />
                    ))}
                </div>
            </section>

        </div>
    );
};